import { RewardsIcons } from './icons'
import { RewardsNavigation } from './navigation'
import { RewardsScreens } from './screens'
import { RewardsE2E } from './e2e'
import { RewardsComponents } from './components'

export const Rewards = {
  Components: RewardsComponents,
  E2E: RewardsE2E,
  Navigation: RewardsNavigation,
  Screens: RewardsScreens,
  Icons: RewardsIcons,
}
